import { ActionIcon, Tooltip } from '@mantine/core';

import type { IconButtonViewProps } from './IconButton.types';

export function IconButtonView({
  icon: Icon,
  iconSize = 16,
  label,
  onClick,
  color,
  size = 30,
  radius = 'sm',
  variant = 'default',
  disabled = false,
  loading = false,
  active,
}: IconButtonViewProps) {
  return (
    <Tooltip label={label} openDelay={300} disabled={disabled}>
      <ActionIcon
        aria-label={label}
        aria-pressed={active}
        onClick={onClick}
        color={active != null ? (color ?? (active ? 'brand' : 'gray')) : color}
        size={size}
        radius={radius}
        variant={active ? 'filled' : variant}
        disabled={disabled}
        loading={loading}
      >
        <Icon size={iconSize} />
      </ActionIcon>
    </Tooltip>
  );
}
